import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { DATE_FORMATS } from '../constants';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);

export const tzNow = (timezone: string, dateFormat?: DATE_FORMATS): string => {
  try {
    return dayjs()
      .utc()
      .tz(timezone)
      .format(dateFormat ?? DATE_FORMATS.API_TIME_FULL);
  } catch {
    return utcNow();
  }
};

export const utcNow = (dateFormat?: DATE_FORMATS): string => {
  return dayjs()
    .utc()
    .format(dateFormat ?? DATE_FORMATS.API_TIME_FULL);
};

const validTimezone = (tz: string): boolean => {
  try {
    dayjs().tz(tz);
    return true;
  } catch {
    return false;
  }
};

export const tz2tz = (
  origin: string | Date,
  timezoneOrigin: string,
  timezoneTarget: string,
  dateFormat?: DATE_FORMATS
): string => {
  try {
    if (!validTimezone(timezoneOrigin) || !dayjs(origin).isValid()) {
      timezoneOrigin = 'UTC';
      origin = utcNow();
    }
    const zonedDate = dayjs(origin).tz(timezoneOrigin, true);
    const convertedDate = zonedDate.tz(timezoneTarget);
    return convertedDate.format(dateFormat ?? DATE_FORMATS.API_TIME_FULL);
  } catch {
    return utcNow();
  }
};

/** Devuelve día de la semana como número del 0 al 6 */
export const tzCurrentWeekDay = (timezone: string): number => {
  try {
    return dayjs().utc().tz(timezone).isoWeekday() - 1;
  } catch {
    return dayjs().utc().isoWeekday() - 1;
  }
};

/** Devuelve el día del mes */
export const tzCurrentMonthDay = (timezone: string): number => {
  try {
    return dayjs().utc().tz(timezone).date();
  } catch {
    return dayjs().utc().date();
  }
};

export const utc2tz = (origin: string | Date, timezoneTarget: string, dateFormat?: DATE_FORMATS) =>
  tz2tz(origin, 'UTC', timezoneTarget, dateFormat);
